import React, { memo } from "react";
import { Button, FlatList, Platform, Pressable, StyleSheet, Text, View } from "react-native";
import * as Clipboard from 'expo-clipboard';
import * as Linking from 'expo-linking';
import { Feather } from '@expo/vector-icons';
import { MaterialCommunityIcons } from '@expo/vector-icons';

import dimensions from "../../globalStyles/dimensions";
import GlobalStyles from "../../globalStyles/globalStyles";
import ModalComponent from "../ModalComponent";
import ExperienceIcons from "../../assets/Icons/ExperienceIcons";
import { BlurView } from "expo-blur";
import { Colors } from "../../globalStyles/ColorConfig";
import WhatsappIcon from "../../assets/Icons/ExperienceIcons/WhatsappIcon";
const ShareWeb = ({
  Id, 
  visible,
  toggleModal,
}: {
  Id: any;  
  visible: any;
  toggleModal: any;
}) => {
  const [iscopied, setIscopied] = React.useState(false);
  
  const handleCopyURL = async() => {
    await Clipboard.setStringAsync(`https://spark-love.vercel.app//experience/?_id=${Id}`);
    setIscopied(true)
    setTimeout(()=> {
      setIscopied(false)
    },2000)
  }

  const shareOnWhatsApp = () => {
    const message = `https://spark.love/spark/experience/?_id=${Id}`
    const url = `whatsapp://send?text=${encodeURIComponent(message)}}`;
    Linking.canOpenURL(url)
    .then((supported) => {
      if (!supported) {
        console.log("WhatsApp is not installed.");
        // Fallback to opening WhatsApp Web in a new tab for unsupported platforms
        window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
      } else {
        return Linking.openURL(url);
      }
    })
    .catch((err) => console.error('An error occurred', err));
  };

  const shareOnEmail = () => {
    const subject = 'Want to experience on Spark';
    const url = `https://spark.love/spark/experience/?_id=${Id}`; // Replace with your URL
  
    let urlEncodedBody = encodeURIComponent(url);
  
    if (Platform.OS === 'web') {
      window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${urlEncodedBody}`, '_blank');
    } else {
      Linking.openURL(`mailto:?subject=${encodeURIComponent(subject)}&body=${urlEncodedBody}`);
    }
  };

  return (
    <ModalComponent isVisible={visible} toggleModal={toggleModal}>
      <BlurView
        intensity={50}
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.67)",
          zIndex: 1,
        }}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalWrap}>
            <View style={styles.container}>
              <View style={styles.header}>
                <Text style={[GlobalStyles.heading3]}>Share this experience</Text>
                <Pressable onPress={toggleModal}>
                  <ExperienceIcons.Cross />
                </Pressable>
              </View>
              <View style={{
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 10
              }}>
                {
                    iscopied && (
                        <View style={{backgroundColor: 'green', borderRadius: 8}}>
                            <Text style={{color: Colors.white000, paddingVertical: 2, paddingHorizontal: 10}}>copied</Text>
                        </View>
                    )
                }
                <Pressable style={{
                    borderWidth: 0.2,
                    borderColor: Colors.black100,
                    borderRadius: 10,
                    padding: 10,
                    width: '100%',
                    alignItems: 'center',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    gap: 10
                }} 
                    onPress={()=> handleCopyURL()}
                >
                    <Text>Copy the URL</Text>
                    <Feather name="copy" size={20} color="black" />
                </Pressable>
                <Pressable style={{
                    borderWidth: 0.2,
                    borderColor: Colors.black100,
                    borderRadius: 10,
                    padding: 10,
                    width: '100%',
                    alignItems: 'center',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    gap: 10
                }}
                    onPress={shareOnWhatsApp}
                >
                    <Text>Share on Whatsapp</Text>
                    <WhatsappIcon/>
                </Pressable>
                <Pressable style={{
                    borderWidth: 0.2,
                    borderColor: Colors.black100,
                    borderRadius: 10,
                    padding: 10,
                    width: '100%',
                    alignItems: 'center',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    gap: 10
                }}
                    onPress={shareOnEmail}
                >
                    <Text>Share on Email</Text>
                    <MaterialCommunityIcons name="email-multiple-outline" size={20} color="black" />
                </Pressable>
              </View>
            </View>
          </View>
        </View>
      </BlurView>
    </ModalComponent>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: "rgba(169, 169, 169, 0.60)",
    flex: 1,
  },
  modalWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    height: "100%",
  },
  container: {
    position: "absolute",
    paddingHorizontal: Platform.OS === "web" ? 20 : dimensions.paddingHorizontal,
    paddingVertical: Platform.OS === "web" ? 20 : dimensions.paddingVertical,
    backgroundColor: "white",
    bottom: 10,
    width: '90%',
    borderRadius: 10
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: dimensions.marginVertical,
  },
  itemContainer: {
    marginBottom: dimensions.marginVertical,
  },
  itemName: {
    marginBottom: dimensions.marginVertical,
  },
  itemDesc: {
    color: "gray",
  },
});

export default memo(ShareWeb);
